var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavourite = function SvgFavourite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.38,
    d: "M20.166 8.124c0 1.417-.544 2.779-1.516 3.786-2.237 2.32-4.408 4.738-6.729 6.973a1.34 1.34 0 0 1-1.885-.041L3.35 11.91c-2.021-2.095-2.021-5.478 0-7.573a5.116 5.116 0 0 1 7.407 0L11 4.59l.243-.252a5.15 5.15 0 0 1 3.704-1.587c1.393 0 2.725.572 3.704 1.587a5.45 5.45 0 0 1 1.516 3.787Z"
  })));
};
export default SvgFavourite;